"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _head = _interopRequireDefault(require("next/head"));

var _locales = require("@meepshop/locales");

// import
require("./styles/index.less");

var styles = {
  "root": "store-refactor__Error-index__root",
  "img": "store-refactor__Error-index__img",
  "title": "store-refactor__Error-index__title",
  "message": "store-refactor__Error-index__message",
  "button": "store-refactor__Error-index__button"
}; // definition

var _default = function _default() {
  var _useTranslation = (0, _locales.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, "404 Page not found")), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: styles.img,
    src: require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/_OACSwXnnU0wfyDGxl8EapXdcmnvERkI2lrN99nZSEY/w:635/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZU5vdEZvdW5kLnN2Zw.svg",
      production: "https://img.meepshop.com/M0ly-qmlWzUe1_kiSI6rRkQYs21v0hjZfu4d2DuJeCg/w:635/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZU5vdEZvdW5kLnN2Zw.svg"
    }),
    alt: "oops"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.title
  }, t('page-not-found.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.message
  }, t('page-not-found.message')), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.message
  }, "Oops! Page not found."), /*#__PURE__*/_react["default"].createElement("a", {
    href: "/"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.button
  }, t('back-to-homepage')))));
};

exports["default"] = _default;